import type {
  CreateClientResponseDTO,
  LoginRequest,
  LoginResponse,
  PasswordResetConfirmRequest,
  PasswordResetRequest,
  RotateSecretResponseDTO,
  SignUpRequest,
  SignUpResponse,
} from "sandbox/types";

import { useSandboxMutation } from "./useSandboxApi";

export const useSignIn = () =>
  useSandboxMutation<LoginResponse, LoginRequest>("/login");

export const useSignUp = () =>
  useSandboxMutation<SignUpResponse, SignUpRequest>("/signup");

export const useResetRequest = () =>
  useSandboxMutation<unknown, PasswordResetRequest>("/password-reset/request");

export const useResetConfirm = () =>
  useSandboxMutation<unknown, PasswordResetConfirmRequest>(
    "/password-reset/confirmation",
  );

export const useUpdatePassword = () =>
  useSandboxMutation<unknown, { old_password: string; new_password: string }>(
    "/password/change",
    { auth: { mode: "authenticated" } },
  );

export const useCreateClient = () =>
  useSandboxMutation<CreateClientResponseDTO, { name: string }>("/clients", {
    auth: { mode: "authenticated" },
  });

export const useDeleteClient = () =>
  useSandboxMutation<unknown, { client_id: string }>(
    ({ client_id }) => `/clients/${client_id}`,
    { method: "DELETE", auth: { mode: "authenticated" } },
  );

export const useRotateClientSecret = () =>
  useSandboxMutation<RotateSecretResponseDTO, { client_id: string }>(
    ({ client_id }) => `/clients/${client_id}/rotate-secret`,
    { auth: { mode: "authenticated" } },
  );

export const useSubmitFeedback = () =>
  useSandboxMutation<unknown, unknown>("/feedback", {
    method: "POST",
    auth: { mode: "authenticated" },
  });
